import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Chip,
  Divider
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import CategoryIcon from '@mui/icons-material/Category';
import PublicIcon from '@mui/icons-material/Public';
import DateRangeIcon from '@mui/icons-material/DateRange';
import InfoIcon from '@mui/icons-material/Info';
import { SectionTitle } from './styles';
import { getStatusIcon } from './statusUtils';
import dayjs from "dayjs";

export const ResponseInfo = ({ member }) => {
  // Check if feedback exists and is not empty
  const hasFeedback = member.response.additionalFeedback && member.response.additionalFeedback.trim() !== '';


  return (
    <Box>
      {/* Member info in a compact layout */}
      <Box sx={{ mb: 3 }}>
        <Paper variant="outlined" sx={{ p: 1.5, bgcolor: "#f8f9fa" }}>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
              <PersonIcon fontSize="medium" color="primary" sx={{ mr: 0.75 }} />
              <Typography variant="body2" noWrap>
                <Typography component="span" fontWeight="large">{member.username}</Typography>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
              <CategoryIcon fontSize="small" color="primary" sx={{ mr: 0.75 }} />
              <Typography variant="body2" noWrap>
                {member.category}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
              <PublicIcon fontSize="small" color="primary" sx={{ mr: 0.75 }} />
              <Typography variant="body2" noWrap>
                {member.region || 'N/A'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
              <DateRangeIcon fontSize="small" color="primary" sx={{ mr: 0.75 }} />
              <Typography variant="body2" noWrap>
                {member.response.createdAt
                  ? dayjs(member.response.createdAt).format("MM/DD/YYYY")
                  : "N/A"}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Box>

      <SectionTitle variant="h6">Impact Assessment Summary</SectionTitle>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} md={! member.response.isComplient ? 6 : 12}>
            <Box display="flex" alignItems="center">
              {getStatusIcon(member.response.isComplient ? "compliant" : "incompliant")}
              <Typography variant="body1" fontWeight="medium" sx={{ ml: 1 }}>
                {member.response.isCompliant ? "Compliant" : "InCompliant"}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Feedback</Typography>

            {hasFeedback ? (
              <Paper variant="outlined" sx={{ p: 2, bgcolor: "#f5f5f5" }}>
                <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
                  {member.response.additionalFeedback}
                </Typography>
              </Paper>
            ) : (
              <Paper variant="outlined" sx={{ p: 2, bgcolor: "#f5f5f5", color: "text.secondary" }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <InfoIcon sx={{ fontSize: 20, mr: 1 }} />
                  <Typography variant="body2">No feedback provided</Typography>
                </Box>
              </Paper>
            )}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
